// --- Science Direct Technology ---

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ElsRadioButton from '../ui/elsRadioButton';

export class ChooseOrgOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 'chooseorg-option-0',
    };
  }

  changeOrg = (ev) => {
    this.setState({
      selected: ev.target.id,
    });
  };

  render() {
    const {
      organizationList,
    } = this.props;
    return (
      <div className="chooseorg-options">
        {
          organizationList ? organizationList.map((org, index) => (
            <div className="chooseorg-option-container" key={org.id}>
              <ElsRadioButton
                id={`chooseorg-option-${index}`}
                name="dept"
                value={org.id}
                label={org.name}
                onChange={this.changeOrg}
                checked={this.state.selected === `chooseorg-option-${index}`}
              />
            </div>
          )) : ''
        }
      </div>
    );
  }
}

ChooseOrgOptions.propTypes = {
  organizationList: PropTypes.array,
};
